module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('list', {
    attrs: {
      "listLogo": _vm.module.logo,
      "listTitle": _vm.$t(((_vm.module.identifier) + ".feed.list.label")),
      "loading": _vm.fetching,
      "typesListAvailable": ['displayList'],
      "total": _vm.totalFeeds
    },
    on: {
      "change": _vm.onChange
    }
  }, [_c('button', {
    staticClass: "btn btn--info",
    class: {
      'is-loading': _vm.creating
    },
    attrs: {
      "slot": "header-actions",
      "disabled": _vm.creating
    },
    on: {
      "click": _vm.showModalCreateFeed
    },
    slot: "header-actions"
  }, [_vm._v(_vm._s(_vm.$t(((_vm.module.identifier) + ".feed.create.label"))))]), _vm._v(" "), _c('create-modal', {
    key: _vm.creadeModelRender,
    attrs: {
      "moduleIdentifier": _vm.module.identifier
    },
    on: {
      "account": _vm.setTargetAccount,
      "option": _vm.createFeed
    },
    model: {
      value: (_vm.createFeedFlag),
      callback: function($$v) {
        _vm.createFeedFlag = $$v
      },
      expression: "createFeedFlag"
    }
  }), _vm._v(" "), _c('template', {
    slot: "filters"
  }, [_c('form-group', {
    attrs: {
      "label": "Código"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.code),
      expression: "options.code"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.options.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.options, "code", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Sku"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.sku),
      expression: "options.sku"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.options.sku)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.options, "sku", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Status"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.status),
      expression: "options.status"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.statuses), function(status) {
    return _c('option', {
      key: status,
      domProps: {
        "value": status
      }
    }, [_vm._v(_vm._s(_vm.$t(((_vm.module.identifier) + ".feed.statuses." + status + ".label"))))])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Tipo"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.type),
      expression: "options.type"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.types), function(type) {
    return _c('option', {
      key: type,
      domProps: {
        "value": type
      }
    }, [_vm._v(_vm._s(_vm.$t(((_vm.module.identifier) + ".feed.type." + type + ".label"))))])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Em fila"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.queued),
      expression: "options.queued"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "queued", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Sim")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Não")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Data de criação"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "format": "dd/MM/yyyy",
      "start-placeholder": "Data Inicial",
      "end-placeholder": "Data Final"
    },
    model: {
      value: (_vm.createdDate),
      callback: function($$v) {
        _vm.createdDate = $$v
      },
      expression: "createdDate"
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.feeds), function(feed) {
    return (_vm.feeds.length) ? _c('div', {
      key: feed,
      staticClass: "l-col-12@md"
    }, [_c('feed-card', {
      attrs: {
        "feed": feed,
        "moduleIdentifier": _vm.module.identifier
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (!_vm.feeds.length) ? _c('div', {
    staticClass: "l-col u-textCenter"
  }, [_c('panel', [_vm._v("\n      Nenhuma tarefa encontrada.\n    ")])], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53006f26","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Feed/List/Shared.vue
// module id = 3169
// module chunks = 0